export default __webpack_public_path__ + "static/media/arrowLeftIcon.1936fd83.svg";